document.addEventListener('DOMContentLoaded', () => {

      const browser = bowser.getParser(window.navigator.userAgent);
      const isValidBrowser = browser.satisfies({
        chrome: '>48.0.2564.97',
        firefox: '>50.0',
        safari: '>9.1',
        edge: '>15',
        iOS: {
          firefox: '>=26.0',
        },
      });

      if (!isValidBrowser) {
        const appRoot = document.querySelector('ten-app-root');
        appRoot.style.display = 'none';

        const splash = document.querySelector('.splash');
        splash.style.display = 'flex';

        const splashBrowserUnsupported = document.querySelector('.splash__browser-unsupported');
        splashBrowserUnsupported.style.display = 'block';

        const splashLoader = document.querySelector('.splash__loader');
        splashLoader.style.display = 'none';
      }
    });